import React, { useCallback, useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { Character, CharacterAbility, CharacterSpell, BasicCreatureInstance, StoredSpell, SummonInstance, SummonOption2 } from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DandDAPI from '@dndUtilities/system_api';

import LoadingBox from "@components/input/LoadingBox";
import CreatureInstanceInput from "@dndComponents/creature/CreatureInstanceInput";
import { SpellLevel } from '@dndModels/Types';
// import CreatureInstanceInputOld from "@dndComponents/creature/CreatureInstanceInputOld";

interface Props {
  character?: Character;
  obj: SummonOption2;
  spell: CharacterAbility | CharacterSpell | StoredSpell;
  level: SpellLevel;
  display_variant?: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();
const api = DandDAPI.getInstance();

export default function DisplaySummonOption({
  obj,
  spell,
  level,
  character
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ci, setCI] = useState<SummonInstance | BasicCreatureInstance>(new BasicCreatureInstance());

  const load = useCallback( async (char: Character) => {
    // debugger;
    const new_ci = await char_util.createMinion(char, spell, level, obj);
    if (new_ci instanceof SummonInstance || new_ci instanceof BasicCreatureInstance) {
      setCI(new_ci);
    }
    setLoading(false);
  }, []);
  
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      if (character) {
        setLoading(true);
        setTimeout(() => {
          load(character);
        }, 100);
      }
    }
  }, [fetched, character, load]);

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          { obj.name }
        </Grid>
        <Grid size={12}>
          <CreatureInstanceInput
            character={character}
            creature_instance={ci}
            true_id={ci.true_id}
            view_only
          />
        </Grid>
      </Grid>
    );
  }
}
